export const selectSystemSettings = (state) => {
  return state.systemSettings && state.systemSettings.data 
    ? state.systemSettings.data 
    : {};
}; 